export function extractDependencies(code: string): string[] {
  const regex =
    /import\s+['"](@[^'"/]+\/[^'"]+|[^'"/]+)(?:\/[^'"]*)?['"]|\bfrom\s+['"](@[^'"/]+\/[^'"]+|[^'"/]+)(?:\/[^'"]*)?['"]/g;
  const libraries: Set<string> = new Set();
  let match: RegExpExecArray | null;

  while ((match = regex.exec(code)) !== null) {
    let library = match[1] || match[2]; // Prendre le groupe non nul
    if (library) {
      // Si c'est une bibliothèque avec un chemin et un @
      const parts = library.split("/");
      if (parts.length > 1 && parts[0].startsWith("@")) {
        library = parts[0] + "/" + parts[1]; // Récupère le nom complet sans le chemin
      } else {
        library = parts[0]; // Récupère seulement le premier segment
      }
      libraries.add(library); // Ajoute la bibliothèque trouvée
    }
  }

  return Array.from(libraries);
}

export function removeDuplicateFromArray(arr: string[]): string[] {
  const uniqueArray: string[] = [];
  for (const item of arr) {
    if (!uniqueArray.includes(item)) {
      uniqueArray.push(item);
    }
  }
  return uniqueArray;
}

export function cleanDemoOnlyCode(code: string) {
  const lines = code.split("\n");

  let cleanedCode = [];
  let inDemoBlock = false;

  for (let line of lines) {
    if (line.includes("@demo-only-start")) {
      inDemoBlock = true;
      continue;
    }

    if (line.includes("@demo-only-end")) {
      inDemoBlock = false;
      continue;
    }

    if (line.includes("@demo-only") && !inDemoBlock) continue;
    if (!inDemoBlock) cleanedCode.push(line);
  }

  let result = cleanedCode.join("\n");

  result = result.replace(/\n\s*\n/g, "\n\n");

  return result;
}
